"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeVoluntaryAdjustmentsAndPremiums = void 0;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Subtracts voluntary adjustments from total adjustments for each key.
 * 
 * @param {object} voluntary - An object containing voluntary adjustments.
 * @param {object} totals - An object containing total adjustments.
 * 
 * @returns {object} - A new object containing the differences between 
 * voluntary and total adjustments for each key that exists in both objects. 
 * Keys that only exist in `voluntary` are also copied to the result.
 */
var subtractAdjustments = function subtractAdjustments(voluntary, totals) {
  return {
    GST: totals.GST - voluntary.GST,
    HST: totals.HST - voluntary.HST,
    PST: totals.PST - voluntary.PST,
    RST: totals.RST - voluntary.RST,
    net: totals.net - voluntary.net,
    total: totals.total - voluntary.total
  };
};

/**
 * Removes voluntaryBenefit adjustments from an invoice. This is because voluntaryBenefits are employee paid, but they are still included in the account level invoices which can cause some confusion.
 * 
 * This function iterates through invoice adjustments and user adjustments. 
 * For each adjustment:
 *  - If the voluntary adjustment total is not zero, it subtracts the 
 *    voluntary adjustments from the total adjustments
 *  - It then updates the corresponding adjustment object in the invoice.
 * 
 * @param {object} invoice - The invoice object to be modified.
 * The invoice object is expected to have an `adjustments` property 
 * containing an array of adjustment objects, and a `currentTransactions` 
 * property with a `users` property containing user objects. Each user 
 * object should have an `amounts` property with properties for 
 * `voluntaryBenefits.adjustments` and `totals.adjustments`.
 * 
 * @returns {object} - The modified invoice object with voluntary 
 * adjustments removed.
 */
var removeVoluntaryAdjustmentsAndPremiums = exports.removeVoluntaryAdjustmentsAndPremiums = function removeVoluntaryAdjustmentsAndPremiums(invoice) {
  var _iterator = _createForOfIteratorHelper(invoice.adjustments),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var adjustment = _step.value;
      var voluntary = adjustment.amounts.voluntaryBenefits.adjustments;
      var totals = adjustment.amounts.totals.adjustments;
      if (voluntary.total !== 0) {
        // Update adjustment totals
        adjustment.amounts.totals.adjustments = subtractAdjustments(voluntary, totals);

        // Update the Invoice Summary
        invoice.summary.overallSummary.totals.GST -= voluntary.GST;
        invoice.summary.overallSummary.totals.HST -= voluntary.HST;
        invoice.summary.overallSummary.totals.PST -= voluntary.PST;
        invoice.summary.overallSummary.totals.RST -= voluntary.RST;
      }
      invoice.currentTransactions.divisions[adjustment.meta.divisionID].totals.GST -= voluntary.GST;
      invoice.currentTransactions.divisions[adjustment.meta.divisionID].totals.PST -= voluntary.PST;
      invoice.currentTransactions.divisions[adjustment.meta.divisionID].totals.HST -= voluntary.HST;
      invoice.currentTransactions.divisions[adjustment.meta.divisionID].totals.RST -= voluntary.RST;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  for (var _i = 0, _Object$values = Object.values(invoice.currentTransactions.users); _i < _Object$values.length; _i++) {
    var user = _Object$values[_i];
    var taxAndAdjustmentsUpdated = false;
    if (user.amounts.voluntaryBenefits.adjustments.total !== 0) {
      user.amounts.totals.adjustments = subtractAdjustments(user.amounts.voluntaryBenefits.adjustments, user.amounts.totals.adjustments);
      user.amounts.totals.GST -= user.amounts.voluntaryBenefits.adjustments.GST;
      user.amounts.totals.HST -= user.amounts.voluntaryBenefits.adjustments.HST;
      user.amounts.totals.RST -= user.amounts.voluntaryBenefits.adjustments.RST;
      user.amounts.totals.PST -= user.amounts.voluntaryBenefits.adjustments.PST;
      taxAndAdjustmentsUpdated = true;
    }
    if (user.amounts.totals.voluntaryBenefitsGrandTotal !== 0) {
      user.amounts.totals.grandTotal -= user.amounts.totals.voluntaryBenefitsGrandTotal;
      user.amounts.totals.premium -= user.amounts.voluntaryBenefits.premium;
      user.amounts.totals.GST -= user.amounts.voluntaryBenefits.GST;
      user.amounts.totals.HST -= user.amounts.voluntaryBenefits.HST;
      user.amounts.totals.RST -= user.amounts.voluntaryBenefits.RST;
      user.amounts.totals.PST -= user.amounts.voluntaryBenefits.PST;
      taxAndAdjustmentsUpdated = true;
    }
    if (taxAndAdjustmentsUpdated) {
      // If taxes and adjustments were updated, reset taxes to 0
      user.amounts.voluntaryBenefits.GST = 0;
      user.amounts.voluntaryBenefits.PST = 0;
      user.amounts.voluntaryBenefits.RST = 0;
      user.amounts.voluntaryBenefits.HST = 0;
      user.amounts.voluntaryBenefits.adjustments = {
        GST: 0,
        PST: 0,
        RST: 0,
        HST: 0,
        net: 0
      };
    }
  }
  var _iterator2 = _createForOfIteratorHelper(invoice.summary.divisionSummaries),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var division = _step2.value;
      if (division.voluntaryBenefits.adjustments.total !== 0) {
        division.totals.GST -= division.voluntaryBenefits.adjustments.GST;
        division.totals.HST -= division.voluntaryBenefits.adjustments.HST;
        division.totals.RST -= division.voluntaryBenefits.adjustments.RST;
        division.totals.PST -= division.voluntaryBenefits.adjustments.PST;
        division.voluntaryBenefits.GST = 0;
        division.voluntaryBenefits.PST = 0;
        division.voluntaryBenefits.RST = 0;
        division.voluntaryBenefits.HST = 0;
        division.voluntaryBenefits.adjustments.GST = 0;
        division.voluntaryBenefits.adjustments.PST = 0;
        division.voluntaryBenefits.adjustments.RST = 0;
        division.voluntaryBenefits.adjustments.HST = 0;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return invoice;
};